import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange
}: PaginationProps) {
  if (totalPages <= 1) return null;
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  const getPageNumbers = () => {
    const pages: (number | 'ellipsis')[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage <= 3) {
        pages.push(2, 3, 4, 'ellipsis', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push('ellipsis', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push('ellipsis', currentPage - 1, currentPage, currentPage + 1, 'ellipsis', totalPages);
      }
    }
    return pages;
  };
  const pageNumbers = getPageNumbers();
  return <div className="flex flex-col items-center gap-6 mt-16 pt-8 border-t border-[#E8E8E8]" data-id="element-460">
      <div className="flex items-center gap-1" data-id="element-461">
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="w-10 h-10 flex items-center justify-center text-[#1A1A1A] hover:text-[#D4A853] transition-colors disabled:text-[#E8E8E8] disabled:cursor-not-allowed" aria-label="Previous page" data-id="element-462">
          <ChevronLeft size={18} data-id="element-463" />
        </button>

        {pageNumbers.map((page, index) => page === 'ellipsis' ? <span key={`ellipsis-${index}`} className="w-10 h-10 flex items-center justify-center text-[#6B6B6B] text-sm" data-id="element-464">
              ···
            </span> : <button key={page} onClick={() => handlePageChange(page)} className={`w-10 h-10 flex items-center justify-center text-sm font-medium transition-colors ${currentPage === page ? 'bg-[#1A1A1A] text-white' : 'text-[#1A1A1A] hover:bg-[#F5F5F5]'}`} aria-label={`Page ${page}`} aria-current={currentPage === page ? 'page' : undefined} data-id="element-465">
              {page}
            </button>)}

        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="w-10 h-10 flex items-center justify-center text-[#1A1A1A] hover:text-[#D4A853] transition-colors disabled:text-[#E8E8E8] disabled:cursor-not-allowed" aria-label="Next page" data-id="element-466">
          <ChevronRight size={18} data-id="element-467" />
        </button>
      </div>

      <p className="text-xs text-[#6B6B6B] font-['Raleway'] tracking-wide" data-id="element-468">
        Page {currentPage} of {totalPages}
      </p>
    </div>;
}